import FormattedMessage from 'I18n/components/FormattedMessage';
import { useMemo } from 'react';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { Select } from 'foundations-components/transitional/components/Select';
import { getLoadOptions } from './util';
import { jsx as _jsx } from "react/jsx-runtime";
export const AddToList = ({
  listToAdd,
  objectTypeId,
  onListChange
}) => {
  const loadOptions = useMemo(() => getLoadOptions(objectTypeId), [objectTypeId]);
  return /*#__PURE__*/_jsx(FormControl, {
    children: /*#__PURE__*/_jsx(Select, {
      anchorType: "auto",
      loadOptions: loadOptions,
      placeholder: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "reporting-ui-components.export.listModal.listPlaceholder"
      }),
      value: listToAdd,
      onChange: onListChange,
      clearable: true
    })
  });
};
export default AddToList;